export default "__VITE_ASSET__BJbvZXf6__"